export default __webpack_public_path__ + "static/googleplay-44a19bc5b930336e3a06b79e520f3236.svg";